import { useEffect, useRef, useState } from 'react';

const DEFAULT_THRESHOLD = 0.2;

type Options = {
  threshold?: number;
  rootMargin?: string;
};

export const useInView = <T extends Element>(options: Options = {}) => {
  const { threshold = DEFAULT_THRESHOLD, rootMargin } = options;
  const ref = useRef<T | null>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry?.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return { ref, inView };
};
